import { Button, Group, Stack, Text } from "@mantine/core";
import { EDUCATION_LEVEL_OPTIONS, JOB_EDUCATION_LEVEL_OPTIONS } from "../lib/educationCatalog";

type Props = {
  value: string | null;
  onChange: (next: string | null) => void;
  disabled?: boolean;
  label?: string;
  variant?: "candidate" | "job";
};

export function EducationLevelPills({
  value,
  onChange,
  disabled,
  label = "Highest education level",
  variant = "candidate",
}: Props) {
  const options = variant === "job" ? JOB_EDUCATION_LEVEL_OPTIONS : EDUCATION_LEVEL_OPTIONS;
  return (
    <Stack gap="xs">
      <Text size="sm" fw="var(--axio-font-weight-medium)">
        {label}{" "}
        {variant === "job" && (
          <Text span size="xs" c="dimmed">
            (Optional)
          </Text>
        )}
      </Text>
      <Group gap="xs" wrap="wrap">
        {options.map((opt) => (
          <Button
            key={opt.value}
            size="xs"
            variant={value === opt.value ? "filled" : "default"}
            color="violet"
            disabled={disabled}
            onClick={() => onChange(value === opt.value ? null : opt.value)}
          >
            {opt.label}
          </Button>
        ))}
      </Group>
    </Stack>
  );
}
